const getKey = ({
  propertyName,
  target,
  name,
  prefixWithIdEmpresaLogada,
}): string => {
  const idEmpresaLogada = localStorage.getItem('idEmpresaLogada');
  const prefix =
    prefixWithIdEmpresaLogada && idEmpresaLogada ? `${idEmpresaLogada}.` : '';

  const fieldName = name ?? `${target.constructor.name}.${propertyName}.value`
  return `${prefix}${fieldName}`
};

/**
 * Sincroniza atributos das classes com o localStorage do navegador.
 *
 * @param name Chave identificadora desta variável no localStorage.
 * Caso não seja informado, será gerado um nome baseado na classe e
 * no atributo em que este decorator foi colocado.
 * @param prefixWithIdEmpresaLogada Identifica a variável atual prefixando-a pelo idEmpresa
 */
export const LocalStorageDecorator = (
  name?: string,
  prefixWithIdEmpresaLogada = true,
) => (target: any, propertyName: string) => {
  const key = getKey({
    target,
    propertyName,
    name,
    prefixWithIdEmpresaLogada
  });

  Object.defineProperty(target, propertyName, {
    get: (): any => {
      const value = localStorage.getItem(key) || '{}';
      try {
        const data = JSON.parse(value);
        if (typeof data === 'object') {
          return data?.value;
        }
        return data;
      } catch (error) {
        console.error(error);
        return undefined;
      }
    },
    set: (value: any) => {
      if (value === undefined) {
        return localStorage.removeItem(key);
      }
      const data = {
        type: typeof value,
        value
      };
      try {
        const dataString = JSON.stringify(data);
        localStorage.setItem(key, dataString);
      } catch (error) {
        console.error(error);
      }
    }
  });
};
